module.exports = __webpack_public_path__ + "static/media/social-error-missing-permissions-en.c42049f9.png";